export default {
  card: {
    minWidth: 150,
    maxHeight: 75,
    marginBottom: 20,
    marginRight: 10,
    padding: 0
  },
  content: {
    paddingTop: 10
  },
  title: {
    marginBottom: 10,
    textAlign: 'center'
  },
  highlight: {
    textAlign: 'center',
    color: '#2196F3'
  }
};



// WEBPACK FOOTER //
// ./src/views/ViewCustomerCase/Card/Card.css.js